<template>
        <lottie-vue-player
        class="confetti"
        :src="source"
        :player-controls="false"
        autoplay
    >
    </lottie-vue-player>
</template>

<script>
import loadingJSON from '@/assets/animations/json-animations/confetti';

    export default {
        data() {
            return {
                source: JSON.stringify(loadingJSON),
            };
        },

    }
</script>

<style>
.confetti {

    background-color: transparent;
}
</style>
